import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './training/HeroSection';
import { CalendarSection } from './training/CalendarSection';
import { HostingAndClassesSection } from './training/HostingAndClassesSection';
import { RegistrationSection } from './training/RegistrationSection';
export function TrainingPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-911">
      <Navbar data-id="element-912" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-913">
        <HeroSection data-id="element-914" />
        <CalendarSection data-id="element-915" />
        <HostingAndClassesSection data-id="element-916" />
        <RegistrationSection data-id="element-917" />
      </main>
      <Footer data-id="element-918" />
    </div>;
}